import React from 'react';

import { withConfig } from '../common/Block.jsx';
//import { default as Image } from '../common/Image.jsx';

function _Custom(props) {
    if (!props.blockConfig.html || props.blockConfig.html.length == 0) {
        return null;
    }

    var html = props.blockConfig.html;
    // if (html.indexOf('is-card') === -1) {
    //     var imgRegex = new RegExp('<img[\\s\\S]+?>', 'g');
    //     var imgMatches = html.match(imgRegex);
    //     if (imgMatches !== null) {
    //         var classRegex = new RegExp('class="(.+?)"');
    //         var filenameRegex = new RegExp('src="https://cdn.artcld.com/img/(\\S+)"');
    //         var altRegex = new RegExp('alt="(.+?)"');
    
    //         for (var i = 0; i < imgMatches.length; i++) {
    //             var imgMatch = imgMatches[i];
    //             var filenameMatches = imgMatch.match(filenameRegex);
    //             if (filenameMatches !== null && filenameMatches.length > 1) {
    //                 var filename = filenameMatches[1];
    //                 var split = filename.split('.');
    //                 var id = split[0];
    //                 var extension = split[1];
    //                 if (extension != 'jpg') {
    //                     continue;
    //                 }
    
    //                 var className = 'lazyload';
    //                 var classMatches = imgMatch.match(classRegex);
    //                 if (classMatches !== null && classMatches.length > 1) {
    //                     className += " " + classMatches[1];
    //                 }
    
    //                 // var alt = '';
    //                 // var altMatches = imgMatch.match(altRegex);
    //                 // if (altMatches !== null && altMatches.length > 1) {
    //                 //     alt = altMatches[1];
    //                 // }
    //                 // else {
    //                 //     alt = 'Image';
    //                 // }
                    
    //                 var dataSrc;
    //                 const index = Image.sizes.length - 1;
    //                 var dataSrcSet = Image.sizes.map(function (d, i) {
    //                     var url = Image.url({
    //                         id: id,
    //                         extension: extension,
    //                     }, d, d);
    //                     if (i === index) {
    //                         dataSrc = url;
    //                     }
    //                     return `${url} ${d}w`;
    //                 });
    //                 var srcSet = `class="${className}" data-sizes="auto" data-srcset="${dataSrcSet}" data-src="${dataSrc}"`;
    
    //                 var x = imgMatch.replace(classRegex, '');
    //                 x = x.replace(altRegex, '');
    //                 x = x.replace(filenameMatches[0], srcSet);
    //                 html = html.replace(imgMatch, x);
    //             }
    //         }
    //     }
    // }

    const contClass = props.blockConfig.isFullWidth ? "cont--full-width" : "cont";
    return (
        <div className={contClass}>
            <div className="custom__content" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
    );
}
const Custom = withConfig(_Custom);

export default { Component: Custom };